import { render, staticRenderFns } from "./editCompanyapp.vue?vue&type=template&id=2ea959c7&scoped=true"
import script from "./editCompanyapp.vue?vue&type=script&lang=js"
export * from "./editCompanyapp.vue?vue&type=script&lang=js"
import style0 from "./editCompanyapp.vue?vue&type=style&index=0&id=2ea959c7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea959c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ea959c7')) {
      api.createRecord('2ea959c7', component.options)
    } else {
      api.reload('2ea959c7', component.options)
    }
    module.hot.accept("./editCompanyapp.vue?vue&type=template&id=2ea959c7&scoped=true", function () {
      api.rerender('2ea959c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/companyapp/modules/editCompanyapp.vue"
export default component.exports